import moment from 'moment';

export const DIRECTION_LABELS = {
  ORIGIN: 'Out of',
  DESTINATION: 'Into',
  BOTH: 'Both',
};

export const PRODUCT_LABELS = {
  PRIVATE: 'Private',
  SHARED: 'Shared',
  ALL: 'All',
};

export const REASON_LABELS = {
  WEATHER: 'Weather',
  DELAY: 'Delay',
};

// Palette keys handed to the shared `TintedStatusPill` (ui/core/TintedStatusPill) —
// `null` renders its neutral/muted tint. Used for the Active table's colored
// Reason badge.
export const REASON_PALETTES = {
  WEATHER: 'accent',
  DELAY: 'warning',
};

export const HISTORY_STATUS_LABELS = {
  CANCELLED: 'Cancelled',
  EXPIRED: 'Expired',
};

export const reasonCell = (row) => {
  const label = REASON_LABELS[row.reason] || row.reason;
  return row.reasonNote ? `${label} — ${row.reasonNote}` : label;
};

// The History table's combined Direction/Product column, e.g. "Both · All".
export const scopeCell = (row) =>
  `${DIRECTION_LABELS[row.direction] || row.direction} · ${PRODUCT_LABELS[row.productScope] || row.productScope}`;

// `createdByEmail`/`cancelledByEmail` are nullable (the admin lookup can fail) —
// fall back to the stable id so the cell never renders blank.
export const createdByLabel = (row) => row.createdByEmail || row.createdBy;
export const cancelledByLabel = (row) => row.cancelledByEmail || row.cancelledBy;

// 'HH:mm' -> '4:00pm'. Not TIME_SIMPLE ('hh:mm A', e.g. '04:00 PM') — the
// reviewed mockup's window copy is the no-leading-zero/lowercase/no-space form.
const WINDOW_TIME_FORMAT = 'h:mma';
export const formatWindowTime = (hhmm) => moment(hhmm, 'HH:mm').format(WINDOW_TIME_FORMAT);

// windowStart/windowEnd are nullable HH:mm strings, half-open (an unset side
// is null, never '00:00'/'23:59') — only ORIGIN-direction throttles carry a
// window at all, everything else is always "All day".
export const formatWindow = (windowStart, windowEnd) => {
  if (!windowStart && !windowEnd) return 'All day';
  if (!windowStart) return `Before ${formatWindowTime(windowEnd)}`;
  if (!windowEnd) return `After ${formatWindowTime(windowStart)}`;
  return `${formatWindowTime(windowStart)}–${formatWindowTime(windowEnd)}`;
};
